import Seo from './components/feature/Seo';
import WhatsAppButton from "./components/feature/WhatsAppButton";
import AffiliateTracker from "./components/feature/AffiliateTracker";
import AnalyticsTracker from "./components/feature/AnalyticsTracker";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { CartProvider } from "./context/CartContext";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <CartProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <Seo />
          <AnalyticsTracker />
          <AffiliateTracker />
          <AppRoutes />
          <WhatsAppButton />
        </BrowserRouter>
      </CartProvider>
    </I18nextProvider>
  );
}

export default App;
